import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";
import { useFormContext, FormProvider } from "react-hook-form";

import useAuth from "../../../../../hooks/useAuth";
import CustomCheckBox from "../../../../../components/CustomCheckBox";

const MailNotification = (props) => {
  const { user } = useAuth();
  const { validationFields, tenantEmailTemplates } = props;
  const {
    formState: { errors },
  } = useFormContext();

  console.log(tenantEmailTemplates, "tenantEmailTemplates");

  return (
    <Grid container spacing={12} className="row" pt={8} sx={{ paddingLeft: "16px" }}>
      {tenantEmailTemplates.map((tenantEmailTemplate) => {
        return (
          <Grid item md={4}>
            <CustomCheckBox
              defaultValue={true}
              label={tenantEmailTemplate.emailTemplate.emailTemplateName}
              name={`tenantEmailId-${tenantEmailTemplate.tenantEmailId}`}
              type="checkbox"
              my={2}
              fullWidth
              errors={errors}
              fields={validationFields}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default MailNotification;
